export const BLOCKS_CREATE_COUNT_LIMIT = 60;
export const BLOCKS_CREATE_SIZE_LIMIT = 2 * 1024 * 1024; // 2 MB
